import 'reflect-metadata';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { BaseEntity } from './Base/Base.Entity';

@asEntity()
export class ErrorMessageEntity extends BaseEntity {
    protected static _apiRoute: string = 'errors';
    protected static _className: string = 'Errors';

    // #region fields

    @Convertible()
    code!: number;

    @Convertible()
    test!: String;

    @Convertible()
    message!: string;

    @Convertible()
    wallet!: string;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields
}
